var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 3,
    viewBox: "0 0 23 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4443 2.12657V1.33776C22.4443 0.902054 22.0912 0.548828 21.6555 0.548828H12.5832H10.2166H1.14436C0.70867 0.548828 0.355469 0.902054 0.355469 1.33776V2.12657C0.355469 2.56227 0.70867 2.91549 1.14436 2.91549H10.2166H12.5832H21.6555C22.0912 2.91549 22.4443 2.56227 22.4443 2.12657Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.ee2b1d541bea01931ffb25275aefec55.svg";
export { ForwardRef as ReactComponent };